module.exports = __webpack_public_path__ + "media/images/まとめ買い割引_1000円_1280_480-09cab8cac6dbc03ba921712a5f4e91cf.png";